import { useEffect, useState }     from 'preact/hooks';
import { createDirectus, graphql } from '@directus/sdk';

const useInitalData = (apikey) => {

  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPageData = async () => {
    const client = createDirectus(import.meta.env.VITE_DIRECTUS_API_URL).with(graphql());
    try {
      const result = await client.query(`
     query {
       rlx_retailer(filter: {rlx_api_key: {_eq: "${apikey}"}}) {
           retailer_name
           retailer_location
           stores {
              state
              street
              zip
              name
              city
              country
              phone_number
              email
              opening_hours {
                  day
                  is_open
                  start_time_1
                  end_time_1
                  start_time_2
                  end_time_2
              }
           }
           domains(filter: {primary: {_eq: true}}) {
              domain
           }
        }
    }
  `)
      setData(result);
      setIsLoading(false);
    } catch (error) {
      setError(error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchPageData()
  }, []);

  return { data, isLoading, error };

};

export default useInitalData;
